import { Box, Typography } from '@mui/material';
import React from 'react';
import { ITheme } from '../utils/theme';

interface CharacterCountProps {
  currentLength: number;
  maxLength: number;
}

const CharacterCount: React.FC<CharacterCountProps> = ({ currentLength, maxLength }) => {
  const isError = currentLength > maxLength;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Typography sx={(theme: ITheme) => ({ color: isError ? theme.palette.red.A700 : theme.palette.grey[300] })}>
        {currentLength}/{maxLength}
      </Typography>
    </Box>
  );
};

export default CharacterCount;
